module.exports = __webpack_public_path__ + "assets/manage2.963e2150.svg";